import "./import/blocks.js";

$ (function(){

    $('.header__menu__burger, .header .nav_menu ul li a').click(function(){
        $('.header .nav_menu ul').toggleClass('nav_menu__mobil')
    });


    $(window).scroll(function() {
        var height = $(window).scrollTop();

        /*Если сделали скролл на 100px задаём новый класс для header*/
        if(height > 500){
            $('.nav_menu').addClass('nav_menu__black');
        } else{
            /*Если меньше 100px удаляем класс для header*/
            $('.nav_menu').removeClass('nav_menu__black');
        }

    });
})